import { TransferClientCapableFlow } from '@square/dashboard-protos/models/squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step';
import { BannerV2Format } from '@square/dashboard-protos/models/squareup/messageservice/service';
import { BannerDescription } from '@square/dashboard-protos/models/squareup/bbfrontend/common/component/component';
import { OneTrustConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
import { get as persistableGet, set as persistableSet, hasKey as persistableHasKey } from '@square/dashboard-utilities/utils/persistable';
import { FLEXIBLE_TRANSFER_MODAL_SKIPPED_STEP_IDS } from './constants';
export let ClientFlow = /*#__PURE__*/function (ClientFlow) {
  ClientFlow["LINK_BANK_ACCOUNT"] = "LINK_BANK_ACCOUNT";
  ClientFlow["LINK_DEBIT_CARD"] = "LINK_DEBIT_CARD";
  ClientFlow["INSTANT_TRANSFER_LINK_BANK_ACCOUNT_THEN_DEBIT_IF_NECESSARY"] = "INSTANT_TRANSFER_LINK_BANK_ACCOUNT_THEN_DEBIT_IF_NECESSARY";
  ClientFlow["TRANSFER_SETTINGS"] = "TRANSFER_SETTINGS";
  return ClientFlow;
}({});
export function clientFlowEnumToString(clientFlow) {
  switch (clientFlow) {
    case TransferClientCapableFlow.LINK_BANK_ACCOUNT:
      {
        return ClientFlow.LINK_BANK_ACCOUNT;
      }
    case TransferClientCapableFlow.LINK_DEBIT_CARD:
      {
        return ClientFlow.LINK_DEBIT_CARD;
      }
    case TransferClientCapableFlow.INSTANT_TRANSFER_LINK_BANK_ACCOUNT_THEN_DEBIT_IF_NECESSARY:
      {
        return ClientFlow.INSTANT_TRANSFER_LINK_BANK_ACCOUNT_THEN_DEBIT_IF_NECESSARY;
      }
    case TransferClientCapableFlow.TRANSFER_SETTINGS:
      {
        return ClientFlow.TRANSFER_SETTINGS;
      }
    default:
      return '';
  }
}
export function mapBannerVariantToBannerV2Type(variant) {
  switch (variant) {
    case BannerDescription.BannerVariant.BANNER_VARIANT_INFO:
      return BannerV2Format.BannerV2Type.BANNER_V2_TYPE_INFO;
    case BannerDescription.BannerVariant.BANNER_VARIANT_CRITICAL:
      return BannerV2Format.BannerV2Type.BANNER_V2_TYPE_CRITICAL;
    case BannerDescription.BannerVariant.BANNER_VARIANT_WARNING:
    default:
      return BannerV2Format.BannerV2Type.BANNER_V2_TYPE_WARNING;
  }
}
export function hasSkippedStepIds() {
  try {
    return persistableHasKey(FLEXIBLE_TRANSFER_MODAL_SKIPPED_STEP_IDS, OneTrustConsent.FUNCTIONAL);
  } catch {
    return false;
  }
}
export function getSkippedStepIds() {
  try {
    const stepIds = JSON.parse(persistableGet(FLEXIBLE_TRANSFER_MODAL_SKIPPED_STEP_IDS, OneTrustConsent.FUNCTIONAL));
    return Array.isArray(stepIds) && stepIds.every(id => typeof id === 'string') ? stepIds : [];
  } catch {
    return [];
  }
}
export function setSkippedStepIds(stepIds) {
  try {
    const uniqueStepIds = [...new Set(stepIds)];
    persistableSet(FLEXIBLE_TRANSFER_MODAL_SKIPPED_STEP_IDS, JSON.stringify(uniqueStepIds), OneTrustConsent.FUNCTIONAL);
  } catch {
    // Do nothing
  }
}